const initialOptions = ($ddd) => {
  let values = []

  $ddd.querySelectorAll('option').forEach(($option, i) => {
    values[i] = $option.getAttribute('value')
  })

  return values
}
const removeOptions = (options, $ddd) => {
  const $empty_option = document.createElement("option")

  $empty_option.setAttribute('disabled', '')
  $empty_option.setAttribute('selected', '')
  $empty_option.style.display = 'none'

  $ddd.options.length = 0

  $ddd.add($empty_option)
  $ddd.dispatchEvent(new CustomEvent('change'))
}
const addOptions = (options, $ddd) => {
  let   $option
  const initialOptionsValues = initialOptions($ddd)

  Object.getOwnPropertyNames(options).forEach((option, i) => {
    if (initialOptionsValues.indexOf(option) < 0) {
      $option = document.createElement("option")
      $option.value = option
      $option.text = options[option]

      $ddd.add($option)
    }
  })
}
const request = ($ddd, ddd_data, value) => {
  let send_data = {}
      send_data[ddd_data.data] = value

  axios({
    method: ddd_data.method,
    url: ddd_data.url,
    data: send_data
  })
  .then((response) => {
    if (response.data[ddd_data.response].length <= 0) {
      removeOptions(response.data[ddd_data.response], $ddd)

      return false
    }

    addOptions(response.data[ddd_data.response], $ddd)
  })
}

const ddd = ($ddd) => {
  const $field = document.querySelector('[name="' + $ddd.getAttribute('dependent-dropdown') + '"]')

  if (!$field)
    return false

  const ddd_data = {
    url: $ddd.getAttribute('dependent-dropdown-url'),
    method: $ddd.getAttribute('dependent-dropdown-method'),
    data: $ddd.getAttribute('dependent-dropdown-data'),
    response: $ddd.getAttribute('dependent-dropdown-data-response')
  }

  if ($field.value !== "" && $field.value !== undefined && $field.value !== null)
    request($ddd, ddd_data, $field.value)

  $field.addEventListener('change', (e) => {
    request($ddd, ddd_data, e.target.value)
  })
}

class dependentDropdown {
  constructor() {
    this.dom = {
      'ddd': (document.querySelectorAll('[dependent-dropdown]').length > 0) ? document.querySelectorAll('[dependent-dropdown]') : null
    }
  }
  init() {
    if (!this.dom.ddd)
      return false

    this.dom.ddd.forEach(($ddd) => {
      ddd($ddd)
    })
  }
}

export default dependentDropdown
